import dayjs from 'dayjs';
import { ISensor } from 'app/shared/model/sensor.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IUser } from 'app/shared/model/user.model';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';

export interface ISensorData {
  id?: number;
  value?: number | null;
  created?: string | null;
  sensor?: ISensor | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  user?: IUser | null;
  vehiclePosition?: IVehiclePosition | null;
}

export const defaultValue: Readonly<ISensorData> = {};
